// extracted by mini-css-extract-plugin
module.exports = {"source":"SatelliteImageReference_source_1Bhm_"};